import type { IconSvgObject } from './types';

const FlashlightOffIcon: IconSvgObject = [
  ["path", { d: "M16 11L17.2095 8.97683C17.7275 8.07025 18 7.04416 18 6V4C18 2.89543 17.1046 2 16 2H8C7.70653 2 7.42782 2.06321 7.17675 2.17675M6 6C6 7.04416 6.27249 8.07025 6.79054 8.97683L8 11V20C8 21.1046 8.89543 22 10 22H14C15.1046 22 16 21.1046 16 20V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 6L18 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 12V15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default FlashlightOffIcon;
